<template>
  <div class="h-full p-2 m-2 rounded-md bg-neutral-primary">
    <div v-for="item in 17" :key="item" class="p-2 w-full">
      <TextSkeleton height="11px" width="100%" />
    </div>
  </div>
</template>

<script setup lang="ts">
import TextSkeleton from '@/components/TextSkeleton.vue';
</script>
